export default __webpack_public_path__ + "static/media/SchoolLoader.4223bcc3.gif";